/* ═══════════════════════════════════════════
   TORONTO HOT TUBS — Custom Theme JS
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── PRODUCT GRID FILTER ── */
  window.thtFilterGrid = function (btn, tag, gridId) {
    var grid = document.getElementById(gridId);
    if (!grid) return;
    var bar = btn.closest('.tht-filter-row');
    if (bar) bar.querySelectorAll('.tht-fp').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    grid.querySelectorAll('.tht-pc').forEach(function (card) {
      var t = card.dataset.t || '';
      card.style.display = (tag === 'all' || t.indexOf(tag) !== -1) ? '' : 'none';
    });
  };

  /* ── QUOTE ROUTING ── */
  window.thtQuoteFor = function (model) {
    if (window.sessionStorage) sessionStorage.setItem('thtQuoteModel', model);
    // Navigate to /pages/contact
    window.location.href = '/pages/contact?model=' + encodeURIComponent(model);
  };

  /* ── CONTACT FORM PRE-FILL ── */
  function prefillContactModel() {
    var model = '';
    // Try URL param
    try {
      var params = new URLSearchParams(window.location.search);
      model = params.get('model') || '';
    } catch (e) {}
    // Fallback to sessionStorage
    if (!model && window.sessionStorage) {
      model = sessionStorage.getItem('thtQuoteModel') || '';
    }
    if (!model) return;
    var sel = document.querySelector('[data-tht-interest-select]');
    if (!sel) return;
    var lower = model.toLowerCase();
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].text.toLowerCase().indexOf(lower.split(' ')[0]) !== -1) {
        sel.selectedIndex = i;
        break;
      }
    }
  }

  /* ── GHL / FALLBACK FORM SUBMISSION ── */
  window.thtSubmitForm = function (btn, formId) {
    if (btn.disabled) return;

    // Collect
    var form = document.getElementById(formId || 'tht-fallback-form');
    var data = {};
    if (form) {
      form.querySelectorAll('input,select,textarea').forEach(function (el) {
        if (el.name) data[el.name] = el.value;
      });
    }

    // ════════════════════════════════════════════
    // GHL WEBHOOK — replace URL with your webhook
    // In GHL: Automations → Workflows → Webhook trigger
    // Paste your webhook URL below:
    // ════════════════════════════════════════════
    var ghlWebhookUrl = ''; // e.g. 'https://services.leadconnectorhq.com/hooks/xxx/webhook-trigger/yyy'

    if (ghlWebhookUrl) {
      fetch(ghlWebhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, data, {
          source: 'torontohottubs-website',
          tags: ['website-lead', 'hot-tub-quote']
        }))
      }).catch(function () {});
    }

    btn.textContent = '✓ Sent — We\'ll respond within 2 hours!';
    btn.style.background = 'var(--tht-g4)';
    btn.disabled = true;
  };

  /* ── WHATSAPP CHAT WIDGET ── */
  var chatOpen = false;

  window.thtToggleChat = function () {
    chatOpen = !chatOpen;
    var bubble = document.getElementById('thtChatBubble');
    if (bubble) bubble.classList.toggle('open', chatOpen);
    if (chatOpen) {
      var notif = document.querySelector('.tht-chat-notification');
      if (notif) notif.style.display = 'none';
    }
  };

  window.thtCloseChat = function () {
    chatOpen = false;
    var bubble = document.getElementById('thtChatBubble');
    if (bubble) bubble.classList.remove('open');
  };

  function initChatAutoOpen() {
    if (!window.sessionStorage) return;
    if (sessionStorage.getItem('thtChatShown')) return;
    setTimeout(function () {
      chatOpen = true;
      var bubble = document.getElementById('thtChatBubble');
      if (bubble) bubble.classList.add('open');
      var notif = document.querySelector('.tht-chat-notification');
      if (notif) notif.style.display = 'none';
      sessionStorage.setItem('thtChatShown', '1');
    }, 8000);
  }

  /* ── SCROLL ANIMATIONS ── */
  function initScrollAnimations() {
    var targets = document.querySelectorAll('.tht-animate:not([data-anim-init])');
    if (!targets.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (el, i) {
      el.dataset.animInit = '1';
      el.style.transitionDelay = (i * 0.06) + 's';
      obs.observe(el);
    });
  }

  /* ── CITY HERO BG ZOOM ── */
  function initCityHeroBg() {
    setTimeout(function () {
      document.querySelectorAll('.tht-city-hero-bg').forEach(function (el) {
        el.style.transition = 'transform 8s ease';
        el.style.transform = 'scale(1.04)';
      });
    }, 100);
  }

  /* ── HIDE CHAT WIDGET WHILE CART DRAWER IS OPEN (mobile overlap fix) ── */
  function initCartDrawerChatObserver() {
    var cartDrawer = document.querySelector('cart-drawer');
    var chatWidget = document.querySelector('.tht-chat-widget');
    if (!cartDrawer || !chatWidget) return;

    var sync = function () {
      var isOpen = cartDrawer.classList.contains('active') || cartDrawer.hasAttribute('open');
      chatWidget.classList.toggle('tht-cart-open', isOpen);
    };

    var obs = new MutationObserver(sync);
    obs.observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'open'] });
    sync();
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    prefillContactModel();
    initChatAutoOpen();
    initScrollAnimations();
    initCityHeroBg();
    initCartDrawerChatObserver();
  });

  // Re-run animations after Shopify section renders in theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      setTimeout(initScrollAnimations, 100);
    });
  }
})();
